<template>
  <router-view />
  <!-- Global UI singletons — teleported to <body> -->
  <AppToastContainer />
  <AppConfirmDialog />
</template>

<script>
import './assets/styles/main.css';
import AppToastContainer from '@/components/ui/AppToastContainer.vue';
import AppConfirmDialog from '@/components/ui/AppConfirmDialog.vue';

export default {
  name: 'App',
  components: { AppToastContainer, AppConfirmDialog },
};
</script>

<style>
/* Base styles are now in main.css */
</style>
